import React from "react";
import Typical from "react-typical";
import { Link } from "react-scroll";

const Hero = () => {
  return (
    <div className="hero bg-gray-800">
      <div className="container px-4  mx-auto py-24  ">
        <div className="hero-wrapper grid grid-cols-1 md:grid-cols-12 gap-8 items-center">
          <div className="hero-text col-span-6">
            <span className="text-white">
              Hi, I'm{" "}
              <span className="text-red-400 text-lg font-semibold tracking-wide">
                Yusuph{" "}
              </span>{" "}
            </span>
            <h1 className=" font-mono text-xl md:text-5xl lg:text-3xl max-w-xl text-white leading-tight">
              <Typical
                loop={Infinity}
                steps={[
                  "Ethusiastic Dev",
                  1500,
                  "Full stack Developer",
                  1500,
                  "Python stack Dev",
                  1500,
                  "React  Dev",
                  1500,
                ]}
              />
            </h1>
            <p className="text-white text-base leading-relaxed mt-8 font-sans">
              Passionate about building application with front-end and back-end
              operations{" "}
            </p>
            <div className="get-app flex space-x-5 mt-10 justify-center md:justify-center">
              <Link
                to="contact"
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                exact="true"
                className="active bg-red-500 text-white text-base tracking-wide hover:bg-red-600 shadow-md px-6 py-2 rounded-full flex items-center space-x-4"
              >
                Hire me
              </Link>
              <a href="YUSUPHOMARI.pdf" download="YUSUPHOMARICv.pdf">
                <button className="google tracking-wide hover:bg-gray-200 text-white border-2 shadow-md px-3 py-2 rounded-full flex items-center hover:text-gray-900 space-x-4">
                  Get Resume
                </button>
              </a>
            </div>
          </div>

          <div className="hero-image col-span-6 mt-10 items-center justify-center">
            <img
              className="object-cover object-center rounded-full "
              alt="hero"
              src={require("../../assets/profile.jpg").default}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
